import { Injectable, NgZone, inject } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ReportDefectEventData, IDefect } from './defect.models';

/**
 * Service to bridge IVION context menu events to Angular components.
 * Uses NgZone to ensure Angular change detection picks up events from IVION SDK.
 *
 * Migrated from IndoorViewerMediator pattern in legacy app.
 */
@Injectable({
  providedIn: 'root',
})
export class DefectEventService {
  private ngZone = inject(NgZone);

  private reportDefectSubject = new Subject<ReportDefectEventData>();
  private viewDefectSubject = new Subject<IDefect>();

  /**
   * Observable for report defect events.
   * Subscribe to this in components that need to handle defect reporting.
   */
  readonly reportDefect$: Observable<ReportDefectEventData> = this.reportDefectSubject.asObservable();

  /**
   * Observable for "open the detail of this defect" requests coming from outside
   * the defect screens (deep link /defect/{id}).
   */
  readonly viewDefect$: Observable<IDefect> = this.viewDefectSubject.asObservable();

  /**
   * Emit a report defect event.
   * Called from the IVION context menu layer.
   * Uses NgZone to ensure Angular detects the change.
   */
  emitReportDefect(data: ReportDefectEventData): void {
    console.log('[DefectEventService] Emitting report defect event:', data);
    this.ngZone.run(() => {
      this.reportDefectSubject.next(data);
    });
  }

  /**
   * Emit a view defect event: the app component opens the defect detail.
   */
  emitViewDefect(defect: IDefect): void {
    console.log('[DefectEventService] Emitting view defect event:', defect.id);
    this.ngZone.run(() => {
      this.viewDefectSubject.next(defect);
    });
  }
}
